import Vue from 'vue'
import Vuex from 'vuex'
import { authModule } from './auth/AuthStore'
import { dialogModule } from './components/dialog/DialogStore'
import { systemModule } from './system/SystemStore'
import { itemGroupModule } from './objects/item-group/ItemGroupStore'
import { countryModule } from './objects/country/CountryStore'
import { companyModule } from './objects/company/CompanyStore'
import { companyTypeModule } from './objects/company-type/CompanyTypeStore'
import { constructionModule } from './objects/construction/ConstructionStore'
import { cityModule } from './objects/city/CityStore'
import { brandModule } from './objects/brand/BrandStore'
import { manufacturerModule } from './objects/manufacturer/ManufacturerStore'
import { accountsModule } from './objects/accounts/AccountsStore'
import { flagsModule } from './objects/flags/FlagsStore'
import { currencyModule } from './objects/currency/CurrencyStore'
import { itemModule } from '@/store/objects/item/ItemStore'
import { userModule } from './objects/users/UserStore'
import { vehicleModule } from '@/store/objects/vehicle/VehicleStore'
import { measurementUnitsModule } from './objects/measurement-units/MeasurementUnitsStore'
import { paymentConditionsModule } from './objects/payment-conditions/PaymentConditionsStore'
import { departamentModule } from '@/store/objects/departament/DepartamentStore'
import { companyListModule } from '@/store/objects/company-list/CompanyListStore'
import { lineBusinessModule } from '@/store/objects/line-business/LineBusinessStore'
import { parcelModule } from '@/store/objects/parcels/ParcelsStore'
import { pdvBalcaoModule } from './components/pdv/BalcaoStore'
import { billsModule } from '@/store/objects/bills/BillsStore'
import { categoryModule } from '@/store/objects/categories/CategoryStore'
import { isetModule } from '@/store/integration/iset/IsetStore'
import { trayModule } from '@/store/integration/tray/TrayStore'
import { ifoodModule } from '@/store/integration/ifood/IfoodStore'
import { deliveryFeeModule } from '@/store/objects/delivery-fee/DeliveryFeeStore'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    systemModule,
    //Objects
    authModule,
    itemGroupModule,
    companyModule,
    companyTypeModule,
    constructionModule,
    countryModule,
    cityModule,
    brandModule,
    manufacturerModule,
    accountsModule,
    flagsModule,
    currencyModule,
    itemModule,
    userModule,
    vehicleModule,
    measurementUnitsModule,
    paymentConditionsModule,
    departamentModule,
    lineBusinessModule,
    pdvBalcaoModule,
    companyListModule,
    parcelModule,
    billsModule,
    categoryModule,
    isetModule,
    trayModule,
    ifoodModule,
    deliveryFeeModule,
    //Components
    dialogModule,
  },
})
